"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterString = void 0;
function getFilterString(filters) {
    return Object.entries(filters)
        .map(([key, val]) => `${key}: ${typeof val === "string" ? `"${val}"` : val}`)
        .join(", ");
}
exports.getFilterString = getFilterString;
